import { type AxiosRequestConfig } from 'axios'

const updateEventApplication = (id: string, status: string): AxiosRequestConfig => {
  return {
    method: 'PUT',
    url: '/events/applications/item',
    params: {
      id,
      status
    }
  }
}

export { updateEventApplication }
